import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { Typography } from "@mui/material";
import styleCss from "../Style/style";
import { AuthAxios } from "../Utilities/CommonAxios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Button,
  Grid,
} from "@mui/material";

export default function CoPassengerDialog({ open, onClose, onSave, data }) {
  const isEditMode = !!data;
  const formik = useFormik({
    initialValues: {
      passanger_id: data?.id || "",
      name: data?.name || "",
      age: data?.age || "",
      gender: data?.gender || "",
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      await addCoPassenger(values);
    },
  });
  const addCoPassenger = async (values) => {
    try {
      const response = await AuthAxios({
        url: "/co_passangers_add_edit",
        method: "post",
        payload: {
          passanger_id: isEditMode ? values.passanger_id : "",
          name: values.name,
          gender: values.gender,
          age: values.age,
        },
      });

      console.log("API response:", response.data);

      if (onSave) onSave(response.data);
      formik.resetForm();
      onClose();
    } catch (error) {
      console.error("Error adding co-passenger:", error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle>
          {isEditMode ? "Edit Co-Passenger" : "Add Co-Passenger"}
        </DialogTitle>
        <DialogContent
          sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}
        >
          <Grid size={{ md: 6, xs: 12 }}>
            <Typography sx={styleCss.CommonLabelName}>Name:</Typography>
            <TextField
              variant="outlined"
              size="small"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#f3f3f5",
                  borderRadius: "8px",
                  minHeight: "32px",
                  padding: 0,
                  "& input": {
                    padding: "12px 10px",
                    fontSize: "15px",
                    "&::placeholder": {
                      fontSize: "15px",
                      color: "#717182",
                      opacity: 1,
                      fontFamily: '"Segoe UI", sans-serif',
                    },
                  },
                  "& fieldset": { borderColor: "#ddd" },
                  "&:hover fieldset": { borderColor: "#bbb" },
                  "&.Mui-focused fieldset": { borderColor: "transparent" },
                },
                "& .MuiInputLabel-root": {
                  fontFamily: '"Segoe UI", sans-serif',
                  fontSize: "15px",
                  color: "#364252",
                },
              }}
            />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <Typography sx={styleCss.CommonLabelName}>Age:</Typography>
            <TextField
              variant="outlined"
              size="small"
              name="age"
              type="number"
              value={formik.values.age}
              // onChange={formik.handleChange}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 3) {
                  formik.handleChange(e);
                }
              }}
              inputProps={{
                maxLength: 3,
              }}
              fullWidth
              sx={{
                "& input[type=number]": {
                  MozAppearance: "textfield",
                },
                "& input[type=number]::-webkit-outer-spin-button": {
                  WebkitAppearance: "none",
                  margin: 0,
                },
                "& input[type=number]::-webkit-inner-spin-button": {
                  WebkitAppearance: "none",
                  margin: 0,
                },
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#f3f3f5",
                  borderRadius: "8px",
                  minHeight: "32px",
                  padding: 0,
                  "& input": {
                    padding: "12px 10px",
                    fontSize: "15px",
                    "&::placeholder": {
                      fontSize: "15px",
                      color: "#717182",
                      opacity: 1,
                      fontFamily: '"Segoe UI", sans-serif',
                    },
                  },
                  "& fieldset": { borderColor: "#ddd" },
                  "&:hover fieldset": { borderColor: "#bbb" },
                  "&.Mui-focused fieldset": { borderColor: "transparent" },
                },
                "& .MuiInputLabel-root": {
                  fontFamily: '"Segoe UI", sans-serif',
                  fontSize: "15px",
                  color: "#364252",
                },
              }}
            />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <Typography sx={styleCss.CommonLabelName}>Gender:</Typography>
            <TextField
              variant="outlined"
              size="small"
              placeholder="Gender"
              name="gender"
              value={formik.values.gender}
              onChange={formik.handleChange}
              select
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#f3f3f5",
                  borderRadius: "8px",
                  minHeight: "32px",
                  padding: 0,
                  "& input": {
                    padding: "12px 10px",
                    fontSize: "15px",
                    "&::placeholder": {
                      fontSize: "15px",
                      color: "#717182",
                      opacity: 1,
                      fontFamily: '"Segoe UI", sans-serif',
                    },
                  },
                  "& fieldset": { borderColor: "#ddd" },
                  "&:hover fieldset": { borderColor: "#bbb" },
                  "&.Mui-focused fieldset": { borderColor: "transparent" },
                },
                "& .MuiInputLabel-root": {
                  fontFamily: '"Segoe UI", sans-serif',
                  fontSize: "15px",
                  color: "#364252",
                },
              }}
            >
              <MenuItem value="">Select Gender</MenuItem>
              <MenuItem value="Male">Male</MenuItem>
              <MenuItem value="Female">Female</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </TextField>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            type="submit"
            variant="contained"
            sx={{
              padding: "7px 1px",
              borderRadius: "7px",
              backgroundColor: "#ff5714",
              fontFamily: "SegoeUI",
              fontSize: "16px",
              fontWeight: "500",
              textAlign: "center",
              color: "#fff",
              fontFamily: '"Segoe UI", sans-serif',
              textTransform: "capitalize",
              width: "15%",
              marginTop: "5px",
              marginRight: "15px",
              marginBottom: "10px",
              "@media (max-width:600px)": {
                marginTop: "15px",
              },
            }}
          >
            {isEditMode ? "Update" : "Save"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
